import React from 'react';
import { motion } from 'framer-motion';

const CENTER = 100;

const polarPoint = (radius, angleDeg) => {
	const angleRad = (angleDeg * Math.PI) / 180;
	return {
		x: CENTER + radius * Math.cos(angleRad),
		y: CENTER + radius * Math.sin(angleRad),
	};
};

const TICK_COUNT = 12;
const ticks = Array.from({ length: TICK_COUNT }, (_, i) => {
	const angle = (360 / TICK_COUNT) * i;
	return { inner: polarPoint(80, angle), outer: polarPoint(92, angle), key: i };
});

const hexTriangle = (radius, offset) =>
	Array.from({ length: 3 }, (_, i) => polarPoint(radius, offset + i * 120))
		.map(p => `${p.x},${p.y}`)
		.join(' ');

const SummoningCircle = () => (
	<div
		className="absolute inset-0 flex items-center justify-center pointer-events-none"
		style={{ filter: 'drop-shadow(0 0 40px rgba(201,164,74,0.6)) drop-shadow(0 0 80px rgba(91,124,250,0.4)) drop-shadow(0 0 120px rgba(245,166,35,0.25))' }}
		aria-hidden="true"
	>
		<motion.svg
			width="680"
			height="680"
			viewBox="0 0 200 200"
			animate={{ opacity: [0.75, 0.7, 0.8, 1, 0.85, 1, 0.9, 0.75] }}
			transition={{
				duration: 3.6,
				repeat: Infinity,
				ease: 'easeInOut',
				times: [0, 0.15, 0.3, 0.38, 0.55, 0.65, 0.85, 1],
			}}
		>
			<defs>
				<radialGradient id="summoningCoreGlow" cx="50%" cy="50%" r="50%">
					<stop offset="0%" stopColor="#ffd166" stopOpacity="1" />
					<stop offset="100%" stopColor="#f5a623" stopOpacity="0" />
				</radialGradient>
			</defs>

			{/* outer static ring */}
			<circle cx={CENTER} cy={CENTER} r={95} fill="none" stroke="#e0bb5f" strokeWidth="0.9" opacity="0.9" />

			{/* rotating tick ring */}
			<motion.g
				style={{ transformOrigin: '50% 50%' }}
				animate={{ rotate: 360 }}
				transition={{ duration: 50, repeat: Infinity, ease: 'linear' }}
			>
				<circle cx={CENTER} cy={CENTER} r={80} fill="none" stroke="#e0bb5f" strokeWidth="1" opacity="0.8" />
				{ticks.map(t => (
					<line
						key={t.key}
						x1={t.inner.x}
						y1={t.inner.y}
						x2={t.outer.x}
						y2={t.outer.y}
						stroke="#f5cf7d"
						strokeWidth="1.8"
						opacity="1"
					/>
				))}
			</motion.g>

			{/* rotating hexagram ring, opposite direction */}
			<motion.g
				style={{ transformOrigin: '50% 50%' }}
				animate={{ rotate: -360 }}
				transition={{ duration: 35, repeat: Infinity, ease: 'linear' }}
			>
				<circle cx={CENTER} cy={CENTER} r={65} fill="none" stroke="#7d97ff" strokeWidth="1" opacity="0.9" />
				<polygon points={hexTriangle(65, -90)} fill="none" stroke="#7d97ff" strokeWidth="1.4" opacity="1" />
				<polygon points={hexTriangle(65, -30)} fill="none" stroke="#7d97ff" strokeWidth="1.4" opacity="1" />
			</motion.g>

			{/* innermost pulsing core */}
			<circle cx={CENTER} cy={CENTER} r={40} fill="none" stroke="#ffd166" strokeWidth="1" opacity="0.9" />
			<motion.circle
				cx={CENTER}
				cy={CENTER}
				r={40}
				fill="url(#summoningCoreGlow)"
				animate={{ scale: [1, 1.35, 1] }}
				transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }}
				style={{ transformOrigin: '50% 50%' }}
			/>
		</motion.svg>
	</div>
);

export default SummoningCircle;
